module.exports = __webpack_public_path__ + "static/media/02.21b5339b.jpg";